import { JSX } from "@emotion/react/jsx-runtime";
import { Typography } from "@mui/material";
import { DynamicContentText } from "../DynamicContentComponent";

export const DynamicTextSection = ({ text, childElements, sxProps }: DynamicContentText): JSX.Element => {
  let sxPropsObject = {};
  if (sxProps) {
    sxPropsObject = sxProps;
  }
  sxPropsObject["whiteSpace"] = "pre-wrap";

  return (
    <Typography variant="h5" align="left" sx={sxPropsObject}>{text}{childElements as unknown as JSX.Element[] || ''} </Typography>
  )
}